import {useParams} from "react-router-dom"
import {Button, IconButton, Paper, Typography, useMediaQuery} from "@mui/material"
import Grid from "@mui/material/Grid"
import {styled} from "@mui/material/styles"
import {AddToCalendarIcon, AppleIcon, CloseIcon, GoogleIcon, OutlookIcon} from "@indebted/assets"
import Modal from "@mui/material/Modal"
import {useAnalytics} from "@indebted/analytics"
import {useState} from "react"

const StyledPaper = styled(({mobile, ...props}) => <Paper {...props} />)(({theme, mobile}) => ({
	position: "relative",
	width: mobile ? "80%" : "400px",
	top: "50%",
	left: theme.direction === "rtl" ? "auto" : "50%",
	right: theme.direction === "rtl" ? "50%" : "auto",
	transform: theme.direction === "rtl" ? "translate(50%, -50%)" : "translate(-50%, -50%)",
	backgroundColor: theme.palette.background.paper,
	boxShadow: theme.shadows[5],
	padding: theme.spacing(2, 4, 2),
	outline: "none",
	borderRadius: "24px",
	paddingBottom: "20px",
}))

export const CalendarModal = ({CalendarURLs, openCalendarModal, headingLabel, buttonLabel}) => {
	const {secureCode} = useParams()
	const [open, setOpen] = useState(!!openCalendarModal)
	const mobile = useMediaQuery("(max-width:599px)")
	const {track} = useAnalytics()

	const handleOpen = () => {
		track("PPAddToCalendarButtonClicked", {
			SecureCode: secureCode,
		})
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
	}

	const openInNewTab = (url: string | URL) => {
		window.open(url, "_blank", "noopener,noreferrer")
	}
	return (
		<>
			<Grid>
				<Button
					style={{borderRadius: "35px", padding: "6px 16px", marginTop: "10px"}}
					type="button"
					onClick={handleOpen}
					variant="outlined"
					startIcon={<AddToCalendarIcon />}
				>
					{buttonLabel}
				</Button>
			</Grid>
			<Modal open={open} onClose={handleClose} aria-labelledby="modal-title" aria-describedby="modal-description">
				<StyledPaper mobile={mobile}>
					<Grid container direction="row" spacing={3} justifyContent="flex-end" alignItems="center">
						<Grid size={{xs: 9, sm: 10}} style={{paddingLeft: "12px"}}>
							<h2 id="modal-title">{headingLabel}</h2>
						</Grid>
						<Grid size={{xs: 3, sm: 2}}>
							<IconButton aria-label="close" onClick={handleClose}>
								<CloseIcon />
							</IconButton>
						</Grid>
					</Grid>
					<Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
						<Grid>
							<Button
								style={{borderRadius: "35px", paddingBottom: "10px"}}
								type="button"
								onClick={() => {
									track("PPGoogleCalendarClicked", {
										SecureCode: secureCode,
									})
									openInNewTab(CalendarURLs.google)
								}}
								variant="text"
								startIcon={<GoogleIcon />}
							>
								<Typography
									align="center"
									variant="subtitle1"
									style={{fontSize: "18px", marginLeft: "10px"}}
								>
									Google calendar
								</Typography>
							</Button>
						</Grid>
						<Grid>
							<Button
								style={{borderRadius: "35px", paddingBottom: "10px"}}
								type="button"
								onClick={() => {
									track("PPAppleCalendarClicked", {
										SecureCode: secureCode,
									})
									openInNewTab(CalendarURLs.apple)
								}}
								variant="text"
								startIcon={<AppleIcon />}
							>
								<Typography
									align="center"
									variant="subtitle1"
									style={{fontSize: "18px", marginLeft: "10px"}}
								>
									Apple calendar
								</Typography>
							</Button>
						</Grid>
						<Grid>
							<Button
								style={{borderRadius: "35px", paddingBottom: "10px"}}
								type="button"
								onClick={() => {
									track("PPOutlookCalendarClicked", {
										SecureCode: secureCode,
									})
									openInNewTab(CalendarURLs.outlook)
								}}
								variant="text"
								startIcon={<OutlookIcon />}
							>
								<Typography
									align="center"
									variant="subtitle1"
									style={{fontSize: "18px", marginLeft: "10px"}}
								>
									Outook calendar
								</Typography>
							</Button>
						</Grid>
					</Grid>
				</StyledPaper>
			</Modal>
		</>
	)
}
